export default "__VITE_ASSET__f3c2ed0c__"